import Signup from "../models/Signup";

const SignupStore = Signup.create();

export default SignupStore;
